export default __webpack_public_path__ + "static/media/blackBackDutyIcon.1c20a961.svg";